import getters from './auditGetters'
import mutations from './auditMutations'
import actions from './auditActions'
import state from './auditState'

export default {
  state,
  getters,
  actions,
  mutations,
}
